export const environment = {
    production: false,
    environment: 'qa',
    baseURL:'https://qa.back.nauffar.com',
    baseUserURL:'https://qa.back.nauffar.com/back',
    encryptionKey: 'QA_AES_ENCRYPTION_KEY_58e7f2a3b9c1d6',
    signingKey: 'QA_HMAC_SIGNING_KEY_71c3d4e5f2a8b9',
    firebase: {
        apiKey: "AIzaSyA3mFySQSJM8guq_l4N51sMSlhJEgEEPQk",
        authDomain: "nauffar-qa.firebaseapp.com",
        projectId: "nauffar-qa",
        storageBucket: "nauffar-qa.firebasestorage.app",
        messagingSenderId: "1052181749239",
        appId: "1:1052181749239:web:9124881cbf7fb77d0662f2"
    }
};
